// extracted by mini-css-extract-plugin
module.exports =  {"button":"ButtonPrimitiveAsLink-module__button___QX3a2"};